type NiftApi = {
  email: string;
  referralCode: string;
};

type CallNiftResponse = {
  available: boolean;
  url: string;
};

export const callNift = async ({email, referralCode}: NiftApi): Promise<CallNiftResponse> => {
  let response: CallNiftResponse = {
    available: false,
    url: '',
  };

  if (!evite.features.isEnabled('nift', false)) {
    return response;
  }

  const resp = await evite.fetch('/ajax/nift/nift-gift-available/', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      // biome-ignore lint/suspicious/noExplicitAny: no any
      'X-CSRFToken': (evite as any).cookie('csrftoken'),
    },
    body: JSON.stringify({
      email,
      // biome-ignore lint/style/useNamingConvention: API expects property name in snake_case
      ...(referralCode && {referral_code: referralCode}),
    }),
  });

  if (resp.ok) {
    const body = await resp.json();
    response = {
      available: body.nift_gift_available,
      url: body.nift_affiliate_url,
    };
  }

  return response;
};
